"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExternalLink = exports.showDownloadIcon = exports.getTabsEnum = exports.getDurationForWebinars = exports.getAdditionalInfoDetails = exports.getAdditionalInfoKey = exports.fetchParameters = exports.isClinicalGuidelineDetail = exports.isJournalDetail = exports.isDownloadDisable = exports.openPdfOrWebview = exports.getExtraCardContent = exports.hideImage = exports.formatOffset = exports.convertISTtoUTC = exports.dateWithOffset = exports.timeWithOffset = exports.getDefaultValue = exports.convertUTCDate = exports.convertUTCTime = exports.getFormattedDateTime = exports.getOnlyTime = exports.getOnlyDate = exports.getDefaultImage = exports.getShowDurationFlag = exports.getHideAuthor = exports.getHideViewsFlag = exports.hideTime = exports.hideDate = exports.getHideInterestFlag = exports.viewDurationInHours = void 0;
const constants_utils_1 = require("./constants.utils");
const moment_1 = __importDefault(require("moment"));
const constants_1 = require("../api/constants");
const imageUtils_1 = require("../imageUtils");
const stores_1 = require("../stores");
const viewDurationInHours = (durationInMins) => {
    if (!durationInMins) {
        return (0, exports.getDefaultValue)();
    }
    const mins = parseInt(durationInMins);
    if (isNaN(mins) || mins < 0) {
        throw new Error('Invalid input. Please provide a non-negative number.');
    }
    const hours = Math.floor(mins / 60);
    const remainingMinutes = mins % 60;
    if (hours > 0 && remainingMinutes > 0) {
        return `${hours}h ${remainingMinutes}m`;
    }
    else if (hours > 0) {
        return `${hours}h`;
    }
    else {
        return `${remainingMinutes}m`;
    }
};
exports.viewDurationInHours = viewDurationInHours;
const getHideInterestFlag = (category, uniqueContentTypeId) => {
    return false;
};
exports.getHideInterestFlag = getHideInterestFlag;
const hideDate = (category, uniqueContentTypeId) => {
    if (category === constants_utils_1.API_CATEGORY_TYPES.KNOWLEDGE_HUB &&
        uniqueContentTypeId === constants_utils_1.CONTENT_TYPE_ID.RESOURCES) {
        return false;
    }
    else if (category !== constants_utils_1.API_CATEGORY_TYPES.LEARNING_CENTER) {
        return true;
    }
    return false;
};
exports.hideDate = hideDate;
const hideTime = (category, uniqueContentTypeId) => {
    if (category !== constants_utils_1.API_CATEGORY_TYPES.LEARNING_CENTER) {
        return true;
    }
    return false;
};
exports.hideTime = hideTime;
const getHideViewsFlag = (category, uniqueContentTypeId) => {
    return false;
};
exports.getHideViewsFlag = getHideViewsFlag;
const getHideAuthor = (category, uniqueContentTypeId) => {
    if (uniqueContentTypeId === constants_utils_1.CONTENT_TYPE_ID.RESOURCES ||
        category === constants_utils_1.API_CATEGORY_TYPES.LEARNING_CENTER ||
        category === constants_utils_1.API_CATEGORY_TYPES.SHALINA_TV) {
        return true;
    }
    return false;
};
exports.getHideAuthor = getHideAuthor;
const getShowDurationFlag = (category, uniqueContentTypeId) => {
    if (category === (constants_utils_1.API_CATEGORY_TYPES === null || constants_utils_1.API_CATEGORY_TYPES === void 0 ? void 0 : constants_utils_1.API_CATEGORY_TYPES.SHALINA_TV)) {
        return true;
    }
    return false;
};
exports.getShowDurationFlag = getShowDurationFlag;
const getDefaultImage = (isDetail, category, uniqueContentTypeId) => {
    if (isDetail) {
        if (category === (constants_utils_1.API_CATEGORY_TYPES === null || constants_utils_1.API_CATEGORY_TYPES === void 0 ? void 0 : constants_utils_1.API_CATEGORY_TYPES.KNOWLEDGE_HUB)) {
            return imageUtils_1.ImageConstant.SOURCE.pdfDetailThumbnail;
        }
        else if (category === (constants_utils_1.API_CATEGORY_TYPES === null || constants_utils_1.API_CATEGORY_TYPES === void 0 ? void 0 : constants_utils_1.API_CATEGORY_TYPES.SHALINA_TV)) {
            return imageUtils_1.ImageConstant.SOURCE.videoDetailThumbnail;
        }
        else if (category === (constants_utils_1.API_CATEGORY_TYPES === null || constants_utils_1.API_CATEGORY_TYPES === void 0 ? void 0 : constants_utils_1.API_CATEGORY_TYPES.LEARNING_CENTER)) {
            return imageUtils_1.ImageConstant.SOURCE.webinarsDetailThumbnail;
        }
        else {
            return imageUtils_1.ImageConstant.SOURCE.cardDefaultThumbnail;
        }
    }
    else {
        if (category === (constants_utils_1.API_CATEGORY_TYPES === null || constants_utils_1.API_CATEGORY_TYPES === void 0 ? void 0 : constants_utils_1.API_CATEGORY_TYPES.KNOWLEDGE_HUB)) {
            if (uniqueContentTypeId === constants_utils_1.CONTENT_TYPE_ID.RESOURCES) {
                return imageUtils_1.ImageConstant.SOURCE.resourcesCardThumbnail;
            }
            return imageUtils_1.ImageConstant.SOURCE.pdfCardThumbnail;
        }
        else if (category === (constants_utils_1.API_CATEGORY_TYPES === null || constants_utils_1.API_CATEGORY_TYPES === void 0 ? void 0 : constants_utils_1.API_CATEGORY_TYPES.SHALINA_TV)) {
            return imageUtils_1.ImageConstant.SOURCE.videoCardThumbnail;
        }
        else if (category === (constants_utils_1.API_CATEGORY_TYPES === null || constants_utils_1.API_CATEGORY_TYPES === void 0 ? void 0 : constants_utils_1.API_CATEGORY_TYPES.LEARNING_CENTER)) {
            return imageUtils_1.ImageConstant.SOURCE.webinarsCardThumbnail;
        }
        else {
            return imageUtils_1.ImageConstant.SOURCE.cardDefaultThumbnail;
        }
    }
    return '';
};
exports.getDefaultImage = getDefaultImage;
const getOnlyDate = (date) => {
    return date ? (0, moment_1.default)(date).format('DD MMM, YYYY') : (0, exports.getDefaultValue)();
};
exports.getOnlyDate = getOnlyDate;
const getOnlyTime = (date) => {
    return date &&
        !(new Date(date).toUTCString().includes('00:00:00') ||
            new Date(date).toString().includes('00:00:00'))
        ? (0, moment_1.default)(date).format('hh:mm A')
        : (0, exports.getDefaultValue)(); // small hh:mm stands for 12H format
};
exports.getOnlyTime = getOnlyTime;
const getFormattedDateTime = (date) => {
    if (!date)
        return '';
    const momentDate = (0, moment_1.default)(date);
    const now = (0, moment_1.default)();
    const isSameYear = momentDate.year() === now.year();
    const datePart = isSameYear
        ? momentDate.format('DD MMM')
        : momentDate.format('DD MMM, YYYY');
    const timePart = !new Date(date).toUTCString().includes('00:00:00') &&
        !new Date(date).toString().includes('00:00:00')
        ? momentDate.format('hh:mm A')
        : '';
    return timePart ? `${datePart}, ${timePart}` : datePart;
};
exports.getFormattedDateTime = getFormattedDateTime;
const convertUTCTime = (date) => {
    return date ? (0, exports.timeWithOffset)(date) : (0, exports.getDefaultValue)();
};
exports.convertUTCTime = convertUTCTime;
const convertUTCDate = (date) => {
    //convert to local timezone
    if (date) {
        const localDate = (0, exports.dateWithOffset)(date);
        return localDate || null;
    }
    return null;
};
exports.convertUTCDate = convertUTCDate;
const getDefaultValue = () => {
    if (constants_1.SHOW_NOT_AVAILABLE) {
        return constants_utils_1.NOT_AVAILABLE_STRING;
    }
    return '';
};
exports.getDefaultValue = getDefaultValue;
const timeWithOffset = (date) => {
    const timezoneOffset = (0, moment_1.default)().utcOffset();
    const formattedOffset = (0, exports.formatOffset)(timezoneOffset);
    const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60);
    const offsetMinutes = Math.abs(timezoneOffset) % 60;
    const sign = timezoneOffset >= 0 ? '+' : '-';
    let formattedDateTime;
    if (sign === '+') {
        formattedDateTime = (0, exports.convertISTtoUTC)(date, offsetHours, offsetMinutes);
    }
    else {
        formattedDateTime = (0, exports.convertISTtoUTC)(date, -offsetHours, -offsetMinutes);
    }
    const formattedDate = (0, moment_1.default)(formattedDateTime).format('hh:mm A');
    return `${formattedDate} (${formattedOffset})`;
};
exports.timeWithOffset = timeWithOffset;
const dateWithOffset = (date) => {
    const timezoneOffset = (0, moment_1.default)().utcOffset();
    const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60);
    const offsetMinutes = Math.abs(timezoneOffset) % 60;
    const sign = timezoneOffset >= 0 ? '+' : '-';
    let formattedDateTime;
    if (sign === '+') {
        formattedDateTime = (0, exports.convertISTtoUTC)(date, offsetHours, offsetMinutes);
    }
    else {
        formattedDateTime = (0, exports.convertISTtoUTC)(date, -offsetHours, -offsetMinutes);
    }
    const formattedDate = (0, moment_1.default)(formattedDateTime).format('DD MMM, YYYY');
    return formattedDate;
};
exports.dateWithOffset = dateWithOffset;
const convertISTtoUTC = (istDateStr, offsetHours, offsetMinutes) => {
    // Create a Date object from the IST date string
    const istDate = new Date(istDateStr);
    // IST is UTC+5:30, so subtract 5 hours and 30 minutes to get UTC time
    const utcDate1 = new Date(istDate.getTime() - 5.5 * 60 * 60 * 1000);
    const utcDate = new Date(utcDate1);
    // Calculate the total offset in milliseconds
    const totalOffsetMilliseconds = offsetHours * 60 * 60 * 1000 + offsetMinutes * 60 * 1000;
    // Adjust the UTC time by the total offset
    const date = new Date(utcDate.getTime() + totalOffsetMilliseconds);
    // Format the NST date to "YYYY-MM-DDTHH:mm:ss"
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const formattedNSTDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    return formattedNSTDate;
};
exports.convertISTtoUTC = convertISTtoUTC;
const formatOffset = (offsetInMinutes) => {
    const hours = Math.floor(Math.abs(offsetInMinutes) / 60);
    const minutes = Math.abs(offsetInMinutes) % 60;
    const sign = offsetInMinutes >= 0 ? '+' : '-';
    return `UTC ${sign}${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}`;
};
exports.formatOffset = formatOffset;
const hideImage = (category, uniqueContentTypeId) => {
    if (uniqueContentTypeId === constants_utils_1.CONTENT_TYPE_ID.JOURNALS_ARTICLES ||
        uniqueContentTypeId === constants_utils_1.CONTENT_TYPE_ID.CLINICAL_GUIDELINES ||
        uniqueContentTypeId === constants_utils_1.CONTENT_TYPE_ID.MAGZINES) {
        return true;
    }
    return false;
};
exports.hideImage = hideImage;
const getExtraCardContent = (category, uniqueContentTypeId) => {
    // if(category === API_CATEGORY_TYPES?.SHALINA_TV) {
    //  return  EXTRA_CARD_CONTENT_STRING.AUTHOR;
    // } else
    if (uniqueContentTypeId === constants_utils_1.CONTENT_TYPE_ID.RESOURCES) {
        return constants_utils_1.EXTRA_CARD_CONTENT_STRING.DATE;
    }
    else if (category !== '' &&
        category !== stores_1.CONTENT_CATEGORY_FIELD_TYPES.SHALINA_TV) {
        return constants_utils_1.EXTRA_CARD_CONTENT_STRING.AUTHOR;
    }
    else if (category === stores_1.CONTENT_CATEGORY_FIELD_TYPES.SHALINA_TV) {
        return constants_utils_1.EXTRA_CARD_CONTENT_STRING.TAGS;
    }
    else {
        return '';
    }
};
exports.getExtraCardContent = getExtraCardContent;
const openPdfOrWebview = (content, category) => {
    var _a, _b;
    if ((content === null || content === void 0 ? void 0 : content.field_is_ebsco) === true || (content === null || content === void 0 ? void 0 : content.field_is_ebsco) === '1') {
        if (category === stores_1.CONTENT_CATEGORY_FIELD_TYPES.SHALINA_TV) {
            return constants_utils_1.CTA_ACTIONS.OPEN_MODAL_WITH_EVENT_URL;
        }
        else {
            if ((_a = content === null || content === void 0 ? void 0 : content.event_data) === null || _a === void 0 ? void 0 : _a.isPdfLink) {
                return constants_utils_1.CTA_ACTIONS.OPEN_PDF;
            }
            else if ((_b = content === null || content === void 0 ? void 0 : content.event_data) === null || _b === void 0 ? void 0 : _b.isSAML) {
                return constants_utils_1.CTA_ACTIONS.OPEN_TAB;
            }
            else {
                return '';
            }
        }
    }
    else {
        return constants_utils_1.CTA_ACTIONS.DEFAULT;
    }
};
exports.openPdfOrWebview = openPdfOrWebview;
const isDownloadDisable = (content, fieldActionId) => {
    var _a, _b;
    const normalizeActions = (actions) => {
        if (!actions)
            return [];
        if (Array.isArray(actions))
            return actions.map(String);
        if (typeof actions === 'string')
            return actions.split(',').map(s => s.trim());
        if (typeof actions === 'number')
            return [String(actions)];
        if (typeof actions === 'object')
            return Object.keys(actions); // ✅ handles object map
        return [];
    };
    const actionsArray = normalizeActions(content === null || content === void 0 ? void 0 : content.field_actions);
    const isDisableFromDrupal = !actionsArray.includes(fieldActionId === null || fieldActionId === void 0 ? void 0 : fieldActionId.toString());
    if (content === null || content === void 0 ? void 0 : content.field_actions) {
        if ((content === null || content === void 0 ? void 0 : content.field_is_ebsco) === true || (content === null || content === void 0 ? void 0 : content.field_is_ebsco) === '1') {
            if ((_a = content === null || content === void 0 ? void 0 : content.event_data) === null || _a === void 0 ? void 0 : _a.isPdfLink) {
                return isDisableFromDrupal;
            }
            else if ((_b = content === null || content === void 0 ? void 0 : content.event_data) === null || _b === void 0 ? void 0 : _b.isSAML) {
                return true;
            }
            else {
                return true;
            }
        }
        else {
            return isDisableFromDrupal;
        }
    }
    else {
        return true;
    }
};
exports.isDownloadDisable = isDownloadDisable;
const isJournalDetail = (unique_code) => {
    return (unique_code === constants_utils_1.CONTENT_TYPE_ID.JOURNALS_ARTICLES ||
        unique_code === constants_utils_1.CONTENT_TYPE_ID.MAGZINES);
};
exports.isJournalDetail = isJournalDetail;
const isClinicalGuidelineDetail = (unique_code) => {
    return unique_code === constants_utils_1.CONTENT_TYPE_ID.CLINICAL_GUIDELINES;
};
exports.isClinicalGuidelineDetail = isClinicalGuidelineDetail;
function parseUrlParams(url) {
    var _a;
    const queryString = (_a = url === null || url === void 0 ? void 0 : url.split('?')) === null || _a === void 0 ? void 0 : _a[1];
    if (!queryString) {
        return {};
    }
    const paramsArray = queryString === null || queryString === void 0 ? void 0 : queryString.split('&');
    const params = {};
    paramsArray === null || paramsArray === void 0 ? void 0 : paramsArray.reduce((accumulator, current) => {
        const [key, value] = current === null || current === void 0 ? void 0 : current.split('=');
        if (key && value) {
            accumulator[key] = decodeURIComponent(value === null || value === void 0 ? void 0 : value.replace(/\+/g, ' '));
        }
        return accumulator;
    }, params);
    return {
        dbId: params['db'],
        an: params['AN'] || params['an'] || params['jid'],
    };
}
const fetchParameters = (eventData) => {
    var _a, _b;
    let params = {
        an: '',
        dbId: '',
    };
    if (eventData === null || eventData === void 0 ? void 0 : eventData.plink) {
        const parameters = parseUrlParams(eventData === null || eventData === void 0 ? void 0 : eventData.plink);
        params = {
            an: parameters === null || parameters === void 0 ? void 0 : parameters.an,
            dbId: parameters === null || parameters === void 0 ? void 0 : parameters.dbId,
        };
    }
    else if (eventData === null || eventData === void 0 ? void 0 : eventData.url) {
        const parameters = parseUrlParams(eventData === null || eventData === void 0 ? void 0 : eventData.url);
        params = {
            an: parameters === null || parameters === void 0 ? void 0 : parameters.an,
            dbId: parameters === null || parameters === void 0 ? void 0 : parameters.dbId,
        };
    }
    else if (eventData === null || eventData === void 0 ? void 0 : eventData.direct_url) {
        const parameters = parseUrlParams(eventData === null || eventData === void 0 ? void 0 : eventData.direct_url);
        params = {
            an: parameters === null || parameters === void 0 ? void 0 : parameters.an,
            dbId: parameters === null || parameters === void 0 ? void 0 : parameters.dbId,
        };
    }
    else if (eventData === null || eventData === void 0 ? void 0 : eventData.header) {
        params = {
            an: (_a = eventData === null || eventData === void 0 ? void 0 : eventData.header) === null || _a === void 0 ? void 0 : _a.An,
            dbId: (_b = eventData === null || eventData === void 0 ? void 0 : eventData.header) === null || _b === void 0 ? void 0 : _b.DbId,
        };
    }
    return params;
};
exports.fetchParameters = fetchParameters;
const getAdditionalInfoKey = (key) => {
    return key ? key === null || key === void 0 ? void 0 : key.replace('_', ' ') : '';
};
exports.getAdditionalInfoKey = getAdditionalInfoKey;
const getAdditionalInfoDetails = (eventData) => {
    if (eventData === null || eventData === void 0 ? void 0 : eventData.additionalInfo) {
        const infoArr = Object.entries(eventData === null || eventData === void 0 ? void 0 : eventData.additionalInfo).map(([key, value]) => ({
            title: (0, exports.getAdditionalInfoKey)(key),
            value: value || constants_utils_1.NOT_AVAILABLE_STRING,
        }));
        if (infoArr && (infoArr === null || infoArr === void 0 ? void 0 : infoArr.length) > 0) {
            return infoArr;
        }
        else {
            return [];
        }
    }
    else {
        return [];
    }
};
exports.getAdditionalInfoDetails = getAdditionalInfoDetails;
const getDurationForWebinars = (startDate, endDate) => {
    return Math.abs((0, moment_1.default)(endDate).diff((0, moment_1.default)(startDate), 'hours'));
};
exports.getDurationForWebinars = getDurationForWebinars;
const getTabsEnum = (unique_code, category) => {
    if (unique_code === constants_utils_1.CONTENT_TYPE_ID.JOURNALS_ARTICLES ||
        unique_code === constants_utils_1.CONTENT_TYPE_ID.MAGZINES) {
        return [constants_utils_1.DETAIL_TABS_ENUM.ARTICLES, constants_utils_1.DETAIL_TABS_ENUM.ADDITIONAL_INFO];
    }
    else if (unique_code === constants_utils_1.CONTENT_TYPE_ID.CLINICAL_GUIDELINES ||
        unique_code === constants_utils_1.CONTENT_TYPE_ID.E_BOOKS) {
        return [constants_utils_1.DETAIL_TABS_ENUM.DESCRIPTION, constants_utils_1.DETAIL_TABS_ENUM.ADDITIONAL_INFO];
    }
    else if (category === constants_utils_1.API_CATEGORY_TYPES.SHALINA_TV ||
        unique_code === constants_utils_1.CONTENT_TYPE_ID.RESOURCES ||
        unique_code === constants_utils_1.CONTENT_TYPE_ID.ARTICLE) {
        return [constants_utils_1.DETAIL_TABS_ENUM.DESCRIPTION];
    }
    return [];
};
exports.getTabsEnum = getTabsEnum;
const showDownloadIcon = (uniqueContentTypeId) => {
    if (uniqueContentTypeId === constants_utils_1.CONTENT_TYPE_ID.RESOURCES || uniqueContentTypeId === constants_utils_1.CONTENT_TYPE_ID.ARTICLE) {
        return true;
    }
    return false;
};
exports.showDownloadIcon = showDownloadIcon;
const isExternalLink = (url, baseUrl) => {
    if (url === null || url === void 0 ? void 0 : url.startsWith(baseUrl)) {
        return false;
    }
    else {
        return true;
    }
};
exports.isExternalLink = isExternalLink;
